<template>
  <div :class="className" :style="{ height: eHeight, width: width }" />
</template>
<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";
const updateFrequency = 3000;
const dimension = 0;
const countryColors = {
  抢夺罪: "#00008b",
  盗窃罪: "#f00",
  诈骗罪: "#ffde00",
  抢劫罪: "#002a8f",
  容留他人吸毒罪: "#003580",
  贩卖毒品罪: "#ed2939",
  强奸罪: "#000",
  强制猥亵妇女罪: "#003897",
  猥亵儿童罪: "#f93",
  服务救助: "#bc002d",
  聚众斗殴罪: "#024fa2",
  寻衅滋事罪: "#000",
  校园霸凌罪: "#00247d",
  故意伤害罪: "#ef2b2d",
  校园严重违纪罪: "#dc143c",
  绑架罪: "#d52b1e",
  敲诈勒索罪: "#e30a17",
  交通肇事罪: "#00247d",
  实物救助: "#b22234",
  大病救助: "#b22239",
};
let res1 = [
  [10, 81.7, 22162863, "抢夺罪", 2017],
  [10, 81.1, 34126173, "盗窃罪", 2017],
  [10, 75.9, 1340968737, "诈骗罪", 2017],
  [10, 78, 11308133, "抢劫罪", 2017],
  [10, 80, 5367693, "容留他人吸毒罪", 2017],
  [10, 81.2, 62961136, "贩卖毒品罪", 2017],
  [10, 80.2, 80435307, "强奸罪", 2017],
  [10, 82.5, 318042, "强制猥亵妇女罪", 2017],
  [10, 65.1, 1230984504, "猥亵儿童罪", 2017],
  [10, 83, 127319802, "服务救助", 2017],
  [10, 70.8, 24500506, "聚众斗殴罪", 2017],
  [10, 80, 49090041, "寻衅滋事罪", 2017],
  [10, 80.5, 4369027, "校园霸凌罪", 2017],
  [10, 80.9, 4891251, "故意伤害罪", 2017],
  [10, 76.1, 38574682, "校园严重违纪罪", 2017],
  [10, 68.7, 143158099, "绑架罪", 2017],
  [10, 75.7, 72310416, "敲诈勒索罪", 2017],
  [10, 80, 62716684, "交通肇事罪", 2017],
  [10, 78.5, 309876170, "实物救助", 2017],
  [10, 81.8, 22542371, "抢夺罪", 2018],
  [10, 81.3, 34499905, "盗窃罪", 2018],
  [10, 76.1, 1348174478, "诈骗罪", 2018],
  [10, 78.1, 11323570, "抢劫罪", 2018],
  [10, 80.3, 5395816, "容留他人吸毒罪", 2018],
  [10, 81.4, 63268405, "贩卖毒品罪", 2018],
  [10, 80.3, 80424665, "强奸罪", 2018],
  [10, 82.7, 321030, "强制猥亵妇女罪", 2018],
  [10, 65.5, 1247446011, "猥亵儿童罪", 2018],
  [10, 82.8, 127252900, "服务救助", 2018],
  [10, 71, 24631359, "聚众斗殴罪", 2018],
  [10, 80.3, 49356692, "寻衅滋事罪", 2018],
  [10, 80.6, 4404483, "校园霸凌罪", 2018],
  [10, 81.1, 4953945, "故意伤害罪", 2018],
  [10, 76.5, 38594217, "校园严重违纪罪", 2018],
  [10, 69.4, 143211476, "绑架罪", 2018],
  [10, 76, 73517002, "敲诈勒索罪", 2018],
  [10, 80.4, 63164949, "交通肇事罪", 2018],
  [10, 78.7, 312390368, "实物救助", 2018],
  [10, 81.8, 22911375, "抢夺罪", 2019],
  [10, 81.4, 34868151, "盗窃罪", 2019],
  [10, 76.3, 1355386952, "诈骗罪", 2019],
  [10, 78.2, 11342631, "抢劫罪", 2019],
  [10, 80.5, 5424644, "容留他人吸毒罪", 2019],
  [10, 81.6, 63561798, "贩卖毒品罪", 2019],
  [10, 80.5, 80477952, "强奸罪", 2019],
  [10, 82.8, 323407, "强制猥亵妇女罪", 2019],
  [10, 65.9, 1263589639, "猥亵儿童罪", 2019],
  [10, 83.2, 127139821, "服务救助", 2019],
  [10, 71.1, 24763353, "聚众斗殴罪", 2019],
  [10, 80.4, 49608451, "寻衅滋事罪", 2019],
  [10, 80.6, 4435883, "校园霸凌罪", 2019],
  [10, 81.3, 5018367, "故意伤害罪", 2019],
  [10, 76.7, 38609486, "校园严重违纪罪", 2019],
  [10, 70.4, 143287536, "绑架罪", 2019],
  [10, 76.2, 74849187, "敲诈勒索罪", 2019],
  [10, 80.8, 63573766, "交通肇事罪", 2019],
  [10, 78.8, 314799465, "实物救助", 2019],
  [10, 81.8, 23270465, "抢夺罪", 2020],
  [10, 81.5, 35230612, "盗窃罪", 2020],
  [10, 76.5, 1362514260, "诈骗罪", 2020],
  [10, 78.3, 11362505, "抢劫罪", 2020],
  [10, 80.6, 5453061, "容留他人吸毒罪", 2020],
  [10, 81.7, 63844529, "贩卖毒品罪", 2020],
  [10, 80.7, 80565861, "强奸罪", 2020],
  [10, 82.8, 325392, "强制猥亵妇女罪", 2020],
  [10, 66.2, 1279498874, "猥亵儿童罪", 2020],
  [10, 83.3, 126984964, "服务救助", 2020],
  [10, 71.2, 24895705, "聚众斗殴罪", 2020],
  [10, 80.5, 49846756, "寻衅滋事罪", 2020],
  [10, 80.6, 4465276, "校园霸凌罪", 2020],
  [10, 81.4, 5083450, "故意伤害罪", 2020],
  [10, 76.9, 38618698, "校园严重违纪罪", 2020],
  [10, 71.3, 143367341, "绑架罪", 2020],
  [10, 76.3, 76223639, "敲诈勒索罪", 2020],
  [10, 81, 63955654, "交通肇事罪", 2020],
  [10, 78.9, 317135919, "实物救助", 2020],
  [10, 81.8, 23622353, "抢夺罪", 2021],
  [10, 81.6, 35587793, "盗窃罪", 2021],
  [10, 76.7, 1369435670, "诈骗罪", 2021],
  [10, 78.4, 11379111, "抢劫罪", 2021],
  [10, 80.7, 5479660, "容留他人吸毒罪", 2021],
  [10, 81.8, 64121249, "贩卖毒品罪", 2021],
  [10, 80.9, 80646262, "强奸罪", 2021],
  [10, 82.8, 327318, "强制猥亵妇女罪", 2021],
  [10, 66.5, 1295291543, "猥亵儿童罪", 2021],
  [10, 83.4, 126794564, "服务救助", 2021],
  [10, 71.3, 25026772, "聚众斗殴罪", 2021],
  [10, 80.6, 50074401, "寻衅滋事罪", 2021],
  [10, 80.6, 4495482, "校园霸凌罪", 2021],
  [10, 81.5, 5147970, "故意伤害罪", 2021],
  [10, 77.1, 38619974, "校园严重违纪罪", 2021],
  [10, 72.21, 143429435, "绑架罪", 2021],
  [10, 76.4, 77523788, "敲诈勒索罪", 2021],
  [10, 81.2, 64331348, "交通肇事罪", 2021],
  [10, 79, 319448634, "实物救助", 2021],
  [10, 81.8, 23968973, "抢夺罪", 2022],
  [10, 81.7, 35939927, "盗窃罪", 2022],
  [10, 76.9, 1376048943, "诈骗罪", 2022],
  [10, 78.5, 11389562, "抢劫罪", 2022],
  [10, 80.8, 5503457, "容留他人吸毒罪", 2022],
  [10, 81.9, 64395345, "贩卖毒品罪", 2022],
  [10, 81.1, 80688545, "强奸罪", 2022],
  [10, 82.8, 329425, "强制猥亵妇女罪", 2022],
  [10, 66.8, 1311050527, "猥亵儿童罪", 2022],
  [10, 83.5, 126573481, "服务救助", 2022],
  [10, 71.4, 25155317, "聚众斗殴罪", 2022],
  [10, 80.7, 50293439, "寻衅滋事罪", 2022],
  [10, 80.6, 4528526, "校园霸凌罪", 2022],
  [10, 81.6, 5210967, "故意伤害罪", 2022],
  [10, 77.3, 38611794, "校园严重违纪罪", 2022],
  [10, 73.13, 143456918, "绑架罪", 2022],
  [10, 76.5, 78665830, "敲诈勒索罪", 2022],
  [10, 81.4, 64715810, "交通肇事罪", 2022],
  [10, 79.1, 321773631, "实物救助", 2022],
];

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    eHeight: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
      option: {},
      timer: null,
      adolescentData:[]
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        // this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons")
      // this.setOptions(this.chartData || {});
    },
    setOptions(data) {
      console.log("青少年分布数据",data)
      let _this = this;
      _this.adolescentData = data;
      // const data = res1;
      const years = [];
      for (let i = 0; i < data.length; ++i) {
        if (years.length === 0 || years[years.length - 1] !== data[i][4]) {
          years.push(data[i][4]);
        }
      }
      let startIndex = 1;
      let startYear = years[startIndex];
      this.option = {
        grid: {
          top: 10,
          bottom: 50,
          left: 150,
          right: 80,
        },
        tooltip: {
          backgroundColor: 'rgba(255,255,255,1)'
        },
        xAxis: {
          max: "dataMax",
          axisLabel: {
            color: _this.isbig ? "#AABEFF" : "",
            formatter: function (n) {
              return Math.round(n) + "";
            },
          },
        },
        dataset: {
          source: data.slice(1).filter(function (d) {
            return d[4] === startYear;
          }),
        },
        yAxis: {
          type: "category",
          inverse: true,
          max: 10,
          axisLabel: {
            show: true,
            fontSize: 14,
            color: _this.isbig ? "#AABEFF" : "",
          },
          animationDuration: 300,
          animationDurationUpdate: 300,
        },
        series: [
          {
            realtimeSort: true,
            seriesLayoutBy: "column",
            type: "bar",
            itemStyle: {
              color: function (param) {
                return countryColors[param.value[3]] || "#5470c6";
              },
            },
            encode: {
              x: dimension,
              y: 3,
            },
            label: {
              show: true,
              precision: 1,
              position: "right",
              valueAnimation: true,
              fontFamily: "monospace",
            },
          },
        ],
        // Disable init animation.
        animationDuration: 0,
        animationDurationUpdate: 2000,
        animationEasing: "linear",
        animationEasingUpdate: "linear",
        graphic: {
          elements: [
            {
              type: "text",
              right: 160,
              bottom: 60,
              style: {
                text: startYear,
                font: "bolder 80px monospace",
                fill: "rgba(100, 100, 100, 0.25)",
              },
              z: 100,
            },
          ],
        },
      };
      if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
    this.chart = echarts.init(this.$el, "macarons");
      this.chart.setOption(this.option);
     
      for (let i = startIndex; i < years.length - 1; ++i) {
        if (!_this.chart) {
          clearTimeout(_this.timer);
          return;
        }
        (function (i) {
          if (!_this.chart) return;
          _this.timer = setTimeout(() => {
            if (!_this.chart) {
              clearTimeout(_this.timer);
              return;
            }
            _this.updateYear(years[i + 1], _this);
          }, (i - startIndex) * 100);
        })(i);
      }
    },
    updateYear(year, _this) {
      let source = _this.adolescentData.slice(1).filter(function (d) {
        return d[4] === year;
      });
      _this.option.series[0].data = source;
      _this.option.graphic.elements[0].style.text = year;
      if (!_this.chart) {
        clearTimeout(_this.timer);
        return;
      }
      _this.chart.setOption(_this.option);
    },
  },
};
</script>
